import React from "react"

import styles from "./ServiceDescriptionList.module.scss"

const ServiceDescriptionList = ({ children }) => {
  return (
    <div className={`${styles.list} base-margin-top-small`}>{children}</div>
  )
}

export default ServiceDescriptionList
